import React from "react";
import styles from "./PromptInputField.module.css";
import { DeleteButton } from "../deleteButton/DeleteButton";

export interface PromptFieldProps {
    readOnly?: boolean;
    disabled?: boolean;
    value: string;
    setValue: (value: string) => void;
    placeholder?: string;
    errorMessage?: string;
    maxLength?: number;
    onDelete?: () => void;
}

export const PromptInputField: React.FC<PromptFieldProps> = ({
    readOnly,
    disabled,
    value,
    setValue,
    placeholder,
    errorMessage,
    maxLength = 30,
    onDelete
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        if (newValue.length <= maxLength) {
            setValue(newValue);
        }
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.inputContainer}>
                <div style={{ position: 'relative', flex: 1, width: '100%' }}>
                    <input
                        value={disabled ? "" : value || ''}
                        readOnly={readOnly}
                        disabled={disabled}
                        placeholder={placeholder}
                        onChange={handleChange}
                        maxLength={maxLength}
                        className={errorMessage ? styles.inputWithError : styles.input}
                    />
                    <div className={styles.counter}>
                        {(value || '').length}/{maxLength}
                    </div>
                </div>
                
                {onDelete && (
                    <DeleteButton
                        disabled={disabled || false}
                        handleClick={onDelete}
                    />
                )}
            </div>
            {errorMessage && (
                <div className={styles.errorWrapper}>
                    <img src="/alertIcon.svg" alt="alert icon" />
                    <span className={styles.errorMessage}>{errorMessage}</span>
                </div>
            )}
        </div>
    );
}; 
